import { setAttributes, getRandomId } from "./DOMutils";

export const setAriaExapndedAttribute = (el, state) => {
    el.setAttribute("aria-expanded", state);
};

export const setInertAttribute = (el, state) => {
    state === false ? el.setAttribute("inert", true) : el.removeAttribute("inert");
};

export const setExpendableAttributes = (toggle, content, condition = false, inertCondition = undefined) => {
    const toggleId = getRandomId("exp-tg");
    const contentId = getRandomId("exp-cnt");

    setAttributes(toggle, {
        "aria-expanded": condition,
        id: toggleId,
        "aria-controls": contentId,
    });
    setAttributes(content, {
        "aria-labelledby": toggleId,
        id: contentId,
        inert: inertCondition === true ? undefined : condition === true ? undefined : true,
    });
};
